module.exports = __webpack_public_path__ + "img/ai_pack.980c8109.png";